module.exports = __webpack_public_path__ + "media/images/playdemoimage-b85bdb4cc474a40478ba31c357a54db6.png";